import * as Sentry from "@sentry/react";

import { processSentryEvent } from "~/v2/utils/sentryFilter";

export function init() {
  Sentry.init({
    dsn: window.env.SENTRY_DSN,
    release: import.meta.env.VITE_APP_VERSION,
    environment: window.env.ENV,
    normalizeDepth: 10,
    attachStacktrace: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.dedupeIntegration(),
      Sentry.extraErrorDataIntegration(),
    ],
    beforeSend: (event, hint) => processSentryEvent(event, hint),
  });
}
